const _header = $("#header");
const _trig_menu = $("#btn-menu");
const _gnav = $("#gnav");
const _overlay = $("#menu-overlay");
const _win = $(window);

const is_window_size = () => {
  let device_type;
  if(window.matchMedia('(max-width:767px)').matches){
    device_type = "sp";
  }else if(window.matchMedia('(min-width:768px)').matches){
    device_type = "pc";
  }
  /*
  if(window.matchMedia('(max-width:1044px)').matches){
    device_type = "header-sp";
  }else if(window.matchMedia('(min-width:1045px)').matches){
    device_type = "header-pc";
  }
  */
  return device_type;
};

// アンカーリンク
$(() => {
  const sec = 500;
  const space = 0;
  let header_h = _header.outerHeight(true) + space;

  $(".js-smooth-scroll").on("click", (eve) => {
    let _this = $(eve.currentTarget);
    header_h = _header.outerHeight(true) + space;

    $("body, html").animate({
      scrollTop: $(_this.attr("href")).offset().top - header_h
    }, sec);
    return false;
  });

  const hash = location.hash;
  if(hash !== ""){
    requestAnimationFrame(() => {
      $("body, html").animate({
        scrollTop: $(hash).offset().top - header_h
      }, sec);
    });
  }
});

$(() => {
  const el = $(".js-mail");
  if (!el) return;
  
  const user = "intggolf";
  const domain = "intloop.com";
  const email = `${user}@${domain}`;
  const email_add_link = $('<a></a>').text(email).attr("href", `mailto:${email}`);

  // 表示（テキストとして入れる）
  el.empty().append(email_add_link);
});

$(() => {
  const _trig_accordion = $(".js-accordion");
  _trig_accordion.each((i, elm) => {
    $(elm).on("click", (eve) => {
      $(eve.currentTarget).toggleClass("is-opened");
    });
  });
});

$(() => {
  const _trig_accordion = $(".js-accordion-cta");
  _trig_accordion.each((i, elm) => {
    $(elm).on("click", (eve) => {
      if(eve.target.closest("a")){
        eve.stopPropagation();
        return;
      }
      $(eve.currentTarget).toggleClass("is-opened");
    });
  });
});




// SPメニュー
const menu_close = () => {
  _gnav.removeClass("is-opened");
  _overlay.removeClass("is-opened");
  $("html").removeClass("is-unscrollable");
};

$(() => {
  const _btn_close = $(".js-close-menu");

  _trig_menu.on("click", (eve) => {
    if(_gnav.hasClass("is-opened")){
      menu_close();
    }else{
      _gnav.addClass("is-opened");
      _overlay.addClass("is-opened");
      $("html").addClass("is-unscrollable");
    }
  });

  _btn_close.on("click", () => {
    menu_close();
  });
});


$(() => {
  const init_num = 10;
  const _card = $("#more-players .c-player-card-small");
  
  _card.each((i, elm) => {
    if(i >= init_num){
      $(elm).hide();
    }
  });

  $("#more-read").on("click", (eve) => {
    _card.each((i, elm) => {
      if(i >= init_num){
        //$(elm).show();
        $(elm).css('display', 'grid');
      }
    });
    $(eve.currentTarget).hide();
  });
});


$(() => {
  //is-fixed
  const $target = $(".js-fixTarget");
  const $trigger = $(".js-fixTrigger");

  let threshold = 0;

  function calcThreshold() {
    const $base = $trigger.length ? $trigger : $target;
    threshold = $base.offset().top + $base.height(); // ドキュメント上のY座標
  }

  function onScroll() {
    if (is_window_size() !== "sp") {
      $target.removeClass('is-fixed');
      return;
    }

    const y = _win.scrollTop();
    $target.toggleClass('is-fixed', y >= threshold);
  }

  // 初期化
  calcThreshold();
  onScroll();

  // スクロール/リサイズで更新
  _win.on('scroll', onScroll);
  _win.on('resize orientationchange', function () {
    calcThreshold();
    onScroll();
  });

  // 画像遅延読込などで位置が変わる場合の保険（必要なら）
  _win.on('load', function () {
    calcThreshold();
    onScroll();
  });
});
